import axios from "axios";
import qs from "qs";
import auth from "@/scripts/auth";
import store from '../store'

axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"; //'multipart/form-data'

function notInterceptorUrl(url) {
	const notInterceptorList = [];
	notInterceptorList.push('/oauth/token');
	notInterceptorList.push('/UrlGen/Bind');
	notInterceptorList.push('/UrlGen/HasBind');
	notInterceptorList.push('/api/Registerv2');
	notInterceptorList.push('/unionregister/register');
	notInterceptorList.push('/api/WxQrToken.ashx');
	notInterceptorList.push('/refresh.qywx');
	notInterceptorList.push('/Account/UserCheck');
	notInterceptorList.push('/api/BossLogin');
	notInterceptorList.push('/api/BossLogin');
	notInterceptorList.push('/UrlGen/SearchOpenId');
	notInterceptorList.push('/api/TencentCaptcha');
	return notInterceptorList.some(list => url.includes(list))
}

// axios.defaults.withCredentials = true; //携带cookie。
// axios.defaults.retry = 3;
// axios.defaults.retryDelay = 500;

//拦截器,可在request和response中判断用户是否登录
axios.interceptors.request.use(function(config) {
	// console.log('config',config)
	//如果是记账专业版，除个别接口外所有jzJMUrls下面的接口域名在此处统一修改成专业版的
	if(store.getters.store_permission === 'jmpro' && !config.url.includes('/odata/AccountSetV3') && !config.url.includes('UserCheck') && !config.url.includes('/api/BossLogin')){
		config.url = config.url.replace('jzJMUrls','jzJMProUrls')
	}

	if(store.getters.store_permission === 'erp' && !config.url.includes('/odata/AccountSetV3') && !config.url.includes('UserCheck') && !config.url.includes('/api/BossLogin')){
		config.url = config.url.replace('jzJMUrls','erpUrls')
	}

	//代账切换成专业版账套时，需要修改接口地址
	if(localStorage.getItem('dzVersion') == 1020){
		config.url = config.url.replace('dzJMUrls','dzJMProUrls')
	}

	//如果是业财专业版，需要改成业财的接口地址
	

	var aaId = localStorage.getItem("AaId");
	var asId = localStorage.getItem("AsId");
	// var aaId = 300360;
	// var asId=100716606;
	// "AsId:100716606","aaid:300360"
	if (aaId * 1) {
		config.headers["AaId"] = aaId;
	}
	if (asId * 1) {
		config.headers["AsId"] = asId;
	}

	if (notInterceptorUrl(config.url)) {
		// 不需要token
		return config;
	}

	let token = JSON.parse(localStorage.getItem('login_user_' + window.lm_env));

	if (!token) {
		_router.navigate("/login/");
		return Promise.reject('未登录');
		// return config;
	}

	if (auth.getInstance.isRefreshing) {
		return auth.getInstance.addConfig(config, auth.getInstance.refresh(token.refresh_token))
	}

	if (!token.expires_time || token.expires_time < new Date().getTime() + 1000) {
		return auth.getInstance.addConfig(config, auth.getInstance.refresh(token.refresh_token))
	}

	config.headers['Authorization'] = token.token_type + ' ' + token.access_token;

	//切换版本接口需要额外添加请求头
	// if(sessionStorage.getItem('serviceId') && (config.url.includes('AccountSetV3')||config.url.includes('plan'))){
	// 	config.headers['service-id'] = sessionStorage.getItem('serviceId')
	// }


	return config;
});
axios.interceptors.response.use(
	function(response) {
		return response.data;
	},
	function(err) {
		if (!_router) {
			console.error("router is not bind",err);
			return Promise.reject(3456);
		}

		_router.navigate("/login/");
		return Promise.reject(3456);
	}
);

var _router = undefined;
var commonCatch = function(err) {
	//return Promise.reject(err);
}
export default {
	bind(router) {
		_router = router
	},
	$get(url, data, completedFunc) {
		// let _qsData = qs.stringify(data, {
		//   arrayFormat: "indices"
		// });
		let http = axios.get(url, {
			params: data
		});
		if (completedFunc) {
			http.then(completedFunc);
		} else {
			return http.catch(commonCatch);
		}
	},
	$postJson(url, data, completedFunc) {
		let _qsData = JSON.stringify(data);
		let http = axios.post(url, _qsData, {
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		});
		if (completedFunc) {
			http.then(completedFunc);
		} else {
			return http.catch(commonCatch);
		}
	},
	$post(url, data, completedFunc) {
		let _qsData = qs.stringify(data, {
			arrayFormat: "indices"
		});
		let http = axios.post(url, _qsData);
		if (completedFunc) {
			http.then(completedFunc);
		} else {
			return http.catch(commonCatch);
		}
	},
	$postFile(url, form) {
		let config = {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		};
		let http = axios.post(url, form, config);
		return http.catch(commonCatch);
	},
	$getFile(url, form) {
		let config = {
			headers: {
				"content-disposition": "attachment; filename=total.xls",
				"content-type": "application/x-download;charset=utf-8"
			}
		};
		let _qsData = qs.stringify(form, {
			arrayFormat: "indices"
		});
		let http = axios.post(url, _qsData, {
			responseType: "blob",
			//headers: config.headers
		});
		return http.catch(commonCatch);
	},
	$delete(url, data, completedFunc) {
		let _qsData = qs.stringify(data, {
			arrayFormat: "indices"
		});
		let http = axios.delete(url, {
			data: _qsData
		});
		if (completedFunc) {
			http.then(completedFunc);
		} else {
			return http.catch(commonCatch);
		}
	},
	$deleteJson(url, data, completedFunc) {
		let _qsData = JSON.stringify(data);
		let http = axios.delete(url, {
			headers: {
				"Content-Type": "application/json"
			},
			data: _qsData
		});
		if (completedFunc) {
			http.then(completedFunc);
		} else {
			return http.catch(commonCatch);
		}
	},
};
